import React from 'react';
import * as S from './ConfirmModal.styled';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmModal({
  isOpen,
  title,
  message,
  confirmText = '확인',
  cancelText = '취소',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <S.ModalOverlay onClick={handleOverlayClick}>
      <S.ModalContent>
        <S.ModalTitle>{title}</S.ModalTitle>
        <S.ModalMessage>{message}</S.ModalMessage>
        <S.ButtonGroup>
          <S.Button variant="secondary" onClick={onCancel}>
            {cancelText}
          </S.Button>
          <S.Button variant="primary" onClick={onConfirm}>
            {confirmText}
          </S.Button>
        </S.ButtonGroup>
      </S.ModalContent>
    </S.ModalOverlay>
  );
}

export default ConfirmModal;
